
import ChargeRegister from "models/charge-register";
import Project from "models/common/project";
export default {
  data() {
    return {
      projectList: [],
      projectListCopy: [],
      projectListByWarehouseAndAuth: []
    }
  },
  created() {
  },
  methods: {
    /**
     * @desc 获取项目数据(根据仓库id搜索用户已有的项目)
     */
    initProjectListByWarehouse(warehouseId) {
      Project.getProjectListByWarehouseAndAuth(warehouseId).then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.projectsName;
            obj.customerId = value.customerId;
            obj.customerName = value.customerName;
            arr.push(obj);
          });
          this.projectList = arr;
          this.projectListCopy = arr;
        }
      });
    },

    /**
     * @desc 获取项目数据(根据仓库id搜索所有项目)
     */
    _getProjectListByWarehouse(warehouseId) {
      Project.getProjectListByWarehouse(warehouseId).then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.projectsName;
            obj.customerId = value.customerId;
            obj.customerName = value.customerName;
            arr.push(obj);
          });
          this.projectList = arr;
          this.projectListCopy = arr;
        }
      });
    },

    /**
     * @desc 获取项目数据(根据仓库id搜索用户已有的项目)
     */
    async initProjectListByWarehouseCopy(warehouseId) {
      let res = await Project.getProjectListByWarehouseAndAuth(warehouseId)
      if (res.success) {
        let arr = [];
        res.result.map(value => {
          let obj = {};
          obj.id = value.id;
          obj.name = value.projectsName;
          obj.customerId = value.customerId;
          obj.customerName = value.customerName;
          arr.push(obj);
        });
        this.projectListByWarehouseAndAuth = arr;
      }
    },

    /**
     * @desc 获取项目数据(根据仓库id搜索) 同步请求 
     */
    async initAsyncProjectListByWarehouse(warehouseId) {
      let res = await Project.getProjectListByWarehouseAndAuth(warehouseId)
      if (res.success) {
        let arr = [];
        res.result.map(value => {
          let obj = {};
          obj.id = value.id;
          obj.name = value.projectsName;
          obj.customerId = value.customerId;
          obj.customerName = value.customerName;
          arr.push(obj);
        });
        this.projectList = arr;
        this.projectListCopy = arr;
      }
    },

    /** 
     * @desc 获取项目名称和客户id(根据仓库id搜索)
    */
    initProjectListByCustomerIdAndWarehouseId(warehouseId) {
      ChargeRegister.getProjectList(warehouseId).then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.customerId = value.customerId;
            obj.name = value.projectsName;
            arr.push(obj);
          });
          this.projectList = arr;
        }
      });
    },
  }
}